<template>
    <div>
        <DetailGadaiKomp :detailGadai="dataCekGadai.gadaiDetail" />
        <div v-if="dataCekGadai.ku != null" class="detail-data-wrapper mt-4 mb-4">
            <h6 class="form-title">LAPORAN KEPALA UNIT</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col>{{ dataCekGadai.ku.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col>{{ dataCekGadai.ku.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                <b-col v-if="dataCekGadai.ku.processedAt != null">
                    {{ $helper.changeDateFormat(dataCekGadai.ku.processedAt) }} {{ $helper.changeDateFormatGetHour(dataCekGadai.ku.processedAt) }}
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                <b-col v-if="dataCekGadai.ku.keterangan != null">{{ dataCekGadai.ku.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="dataCekGadai.kc != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">LAPORAN KEPALA CABANG</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col>{{ dataCekGadai.kc.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col>{{ dataCekGadai.kc.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                <b-col v-if="dataCekGadai.kc.processedAt != null">
                    {{ $helper.changeDateFormat(dataCekGadai.kc.processedAt) }} {{ $helper.changeDateFormatGetHour(dataCekGadai.kc.processedAt) }}
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                <b-col v-if="dataCekGadai.kc.keterangan != null">{{ dataCekGadai.kc.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="dataCekGadai.kcs != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">LAPORAN AREA MANAGER</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col>{{ dataCekGadai.kcs.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col>{{ dataCekGadai.kcs.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                <b-col v-if="dataCekGadai.kcs.processedAt != null">
                    {{ $helper.changeDateFormat(dataCekGadai.kcs.processedAt) }} {{ $helper.changeDateFormatGetHour(dataCekGadai.kcs.processedAt) }}
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                <b-col v-if="dataCekGadai.kcs.keterangan != null">{{ dataCekGadai.kcs.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="dataCekGadai.pusat != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">LAPORAN PUSAT</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col>{{ dataCekGadai.pusat.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col>{{ dataCekGadai.pusat.status }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                <b-col v-if="dataCekGadai.pusat.processedAt != null">
                    {{ $helper.changeDateFormat(dataCekGadai.pusat.processedAt) }} {{ $helper.changeDateFormatGetHour(dataCekGadai.pusat.processedAt) }}
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                <b-col v-if="dataCekGadai.pusat.keterangan != null">{{ dataCekGadai.pusat.keterangan }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-cek-gadai',
    components: {
        DetailGadaiKomp
    },
    props: {
        dataCekGadai: { type: Object, required: true }
    },
}
</script>
